import { Base } from './Base';
import { relewiseTrack } from '../../utilities/relewise';

const data = {}

// window.Cookiebot.consent.marketing = false;

export class RelewiseTrigger extends Base {
    constructor(behaviourName, element) {
        super(behaviourName, element);
        this.init();
    }

    init() {
        const { trigger, crossStoreProductId, currentVariantId } = this.element.dataset;
        
        // console.log("RE / RelewiseTrigger crossStoreProductId: ", crossStoreProductId);
        // console.log("RE / RelewiseTrigger currentVariantId: ", currentVariantId);

        relewiseTrack(trigger, {
            crossStoreProductId,
            variantId: currentVariantId
        });
    }
}